<template>
  <div>
    <br>
    <v-row v-if="resetPassword == 0" style="margin:2px">
      <v-spacer />
      <v-card style="width:90%">
        <v-card-title>Prihlásenie</v-card-title>
        <v-card-text />
        <v-card-text>
        <v-text-field
          variant="outlined"
          label="E-mail:"
          v-model="email"
          />
          <v-text-field
            variant="outlined"
            v-model="password"
            type="password"
            label="Heslo"
          />
          <v-row style="margin-bottom:10px;margin-right:4px">
            <v-spacer/>
            <v-chip style="color:green" small @click="resetPassword = 1">Zabudnuté heslo...</v-chip>
          </v-row>
          <v-row style="margin:2px">
            <v-btn variant="outlined" @click="onSubmit()">Prihlásiť</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
      <v-spacer />
    </v-row>
    <ChangePassword v-if="resetPassword == 1" v-bind:source="1" v-bind:eml="''"/>
  </div>
</template>

<script>

import ChangePassword from './change_password.vue'

  export default {
    data: function () {
      return {
        email: '',
        password: '',
        grant_type:"password",
        client_id: "2",
        client_secret: "iQuGUAzqc187j7IKQ94tTVJAywHCAzYBGAMTxEtr",
        loader: false,
        infoError: false,
        resetPassword: 0,
        show1: false
      }
    },
    components: {
      ChangePassword
    },
    methods: {
      onSubmit () {
        const formData = {
            email: this.email,
            grant_type: this.grant_type,
            client_id: this.client_id,
            client_secret: this.client_secret,
            username: this.email,
            password: this.password
        }
        this.$store.dispatch('login', formData)
      }
    }
  }

</script>